import { MdRocketLaunch } from 'react-icons/md';
import IosCard from './iOSCard';
import MacCard from './MacCard';
import Card from './Card';
import Trackmiles from '../assets/img/projects/trackmiles.jpg';
import Infojobs from '../assets/img/projects/infojobs.jpg';
import Nextil from '../assets/img/projects/nextil.png';
import Propet from '../assets/img/projects/petstore.png';
import BodyTrack from '../assets/img/projects/BodyTrack.png';
import { useTranslate } from 'react-translate';
import nextilApp from '../assets/img/projects/nextil-app.png';
import ImageOptimizer from '../assets/img/projects/image-optimizer.png';

const Projects = () => {
  const t = useTranslate('Projects');

  const projects = [
    {
      title: 'Nextil',
      description: t('nextil'),
      tech: [
        'Next.js',
        'React',
        'Tailwind CSS',
        'TypeScript',
        'Supabase',
        'PostgreSQL',
        'Mapbox API',
        'OpenAI',
        'Stripe',
        'SwiftUI',
      ],
      img: Nextil,
      liveHref: 'https://www.nextil.net/',
    },
    {
      title: 'InfoJobs',
      description: t('infojobs'),
      tech: ['Astro', 'Tailwind CSS', 'TypeScript'],
      img: Infojobs,
      liveHref: 'https://primer-trabajo.infojobs.net/',
      sourceHref: 'https://github.com/midudev/landing-infojobs',
    },
    {
      title: 'ProPet',
      description: t('propet'),
      tech: [
        'React',
        'Redux',
        'Tailwind CSS',
        'JavaScript',
        'Node.js',
        'Express',
        'MongoDB',
        'GraphQL',
        'Stripe',
      ],
      img: Propet,
      liveHref: 'https://pro-pet.raulwebdev.com/',
      sourceHref: 'https://github.com/jimenezraul/pet-supplies-store',
    },
  ];

  const iosT = useTranslate('IOS');

  const iOSProjects = [
    {
      title: 'Nextil',
      description: iosT('nextil_ios_description'),
      tech: ['SwiftUI', 'Supabase', 'Mapbox', 'Stripe'],
      img: nextilApp,
      app: 'https://apps.apple.com/us/app/nextil-appointment-scheduler/id6752634472',
    },
    {
      title: 'BodyTrack',
      description: iosT('bodytrack_description'),
      tech: ['SwiftUI', 'HealthKit', 'MapKit'],
      img: BodyTrack,
      app: 'https://apps.apple.com/app/bodytrack-calories-tracker/id6742031983',
    },
    {
      title: 'TrackMiles',
      description: iosT('trackmiles_description'),
      tech: ['SwiftUI'],
      img: Trackmiles,
      app: 'https://apps.apple.com/us/app/trackmiles/id6503728501',
    },
  ];

  const macT = useTranslate('MacOS');

  const macProjects = [
    {
      title: 'Image Optimizer',
      description: macT('imageoptimizer_description'),
      tech: [
        'Swift',
        'SwiftUI',
        'libwebp',
        'Apple Intelligence',
        'Apple Vision',
        'Ollama',
        'Sparkle',
      ],
      img: ImageOptimizer,
      download: 'https://raulwebdev.com/imageoptimizer/',
    },
  ];

  return (
    <section id='projects' className='py-8 md:py-12'>
      <div className='section-shell'>
        <div className='mb-8 max-w-2xl'>
          <div
            className='section-kicker'
            data-aos='fade-up'
            data-aos-delay='50'
          >
            <MdRocketLaunch />
            {t('title')}
          </div>
          <h2
            className='section-title mt-6'
            data-aos='fade-up'
            data-aos-delay='100'
          >
            {t('headline')}
          </h2>
          <p
            className='section-copy mt-5'
            data-aos='fade-up'
            data-aos-delay='150'
          >
            {t('sub_title')}
          </p>
        </div>

        <div className='grid gap-6 md:grid-cols-2 lg:grid-cols-3'>
          {projects.map((project, index) => (
            <Card key={project.title} {...project} index={index} />
          ))}
        </div>

        <div className='mt-16 mb-8 max-w-2xl'>
          <div
            className='section-kicker'
            data-aos='fade-up'
            data-aos-delay='50'
          >
            <MdRocketLaunch />
            {iosT('title')}
          </div>
          <h2
            className='section-title mt-6'
            data-aos='fade-up'
            data-aos-delay='100'
          >
            {iosT('headline')}
          </h2>
          <p
            className='section-copy mt-5'
            data-aos='fade-up'
            data-aos-delay='150'
          >
            {iosT('subtitle')}
          </p>
        </div>

        <div className='grid gap-6 md:grid-cols-2 lg:grid-cols-3'>
          {iOSProjects.map((project, index) => (
            <IosCard key={project.title} {...project} index={index} />
          ))}
        </div>

        <div className='mt-16 mb-8 max-w-2xl'>
          <div
            className='section-kicker'
            data-aos='fade-up'
            data-aos-delay='50'
          >
            <MdRocketLaunch />
            {macT('title')}
          </div>
          <h2
            className='section-title mt-6'
            data-aos='fade-up'
            data-aos-delay='100'
          >
            {macT('headline')}
          </h2>
          <p
            className='section-copy mt-5'
            data-aos='fade-up'
            data-aos-delay='150'
          >
            {macT('subtitle')}
          </p>
        </div>

        <div className='grid gap-6 md:grid-cols-2 lg:grid-cols-3'>
          {macProjects.map((project, index) => (
            <MacCard key={project.title} {...project} index={index} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
